module.exports = __webpack_public_path__ + "img/tamara.58cca297.png";